[
  ".ac",
  ".ac.in",
  ".ac.jp",
  ".ac.ke",
  ".ac.nz",
  ".ac.pk",
  ".ac.tr",
  ".ac.uk",
  ".ac.za",
  ".academy",
  ".ad",
  ".ae",
  ".af",
  ".ag",
  ".agency",
  ".ai",
  ".al",
  ".am",
  ".ao",
  ".app",
  ".ar",
  ".as",
  ".asn.au",
  ".at",
  ".au",
  ".aw",
  ".az",
  ".ba",
  ".bb",
  ".bd",
  ".be",
  ".bf",
  ".bg",
  ".bh",
  ".bi",
  ".biz",
  ".bj",
  ".bm",
  ".bn",
  ".bo",
  ".blog",
  ".br",
  ".bs",
  ".bt",
  ".bw",
  ".by",
  ".bz",
  ".ca",
  ".cc",
  ".cd",
  ".cf",
  ".cg",
  ".ch",
  ".ci",
  ".ck",
  ".cl",
  ".cloud",
  ".cm",
  ".cn",
  ".co",
  ".co.ae",
  ".co.id",
  ".co.ie",
  ".co.il",
  ".co.in",
  ".co.jp",
  ".co.ke",
  ".co.kr",
  ".co.nz",
  ".co.th",
  ".co.tr",
  ".co.ua",
  ".co.uk",
  ".co.vn",
  ".co.za",
  ".com",
  ".com.ar",
  ".com.au",
  ".com.br",
  ".com.cn",
  ".com.eg",
  ".com.hk",
  ".com.mx",
  ".com.my",
  ".com.ph",
  ".com.pk",
  ".com.sa",
  ".com.sg",
  ".com.tr",
  ".com.ua",
  ".com.vn",
  ".community",
  ".company",
  ".coop",
  ".cr",
  ".cu",
  ".cv",
  ".cx",
  ".cy",
  ".cz",
  ".de",
  ".design",
  ".dev",
  ".digital",
  ".dj",
  ".dk",
  ".dm",
  ".do",
  ".dz",
  ".ec",
  ".edu.ar",
  ".edu.au",
  ".edu.br",
  ".edu.hk",
  ".edu.mx",
  ".edu.ph",
  ".edu.sg",
  ".education",
  ".ee",
  ".eg",
  ".email",
  ".engineering",
  ".er",
  ".es",
  ".et",
  ".eu",
  ".fi",
  ".finance",
  ".fj",
  ".fk",
  ".fm",
  ".fo",
  ".foundation",
  ".fr",
  ".fun",
  ".ga",
  ".gb",
  ".gd",
  ".ge",
  ".gg",
  ".gh",
  ".gi",
  ".gl",
  ".gm",
  ".gn",
  ".go.jp",
  ".go.ke",
  ".gob.mx",
  ".gov.ar",
  ".gov.au",
  ".gov.br",
  ".gov.cn",
  ".gov.hk",
  ".gov.in",
  ".gov.my",
  ".gov.nz",
  ".gov.ph",
  ".gov.sa",
  ".gov.sg",
  ".gov.tr",
  ".gov.ua",
  ".gov.uk",
  ".gov.za",
  ".govt.nz",
  ".gr",
  ".group",
  ".gt",
  ".gu",
  ".gy",
  ".health",
  ".help",
  ".hk",
  ".hn",
  ".host",
  ".hr",
  ".ht",
  ".hu",
  ".id",
  ".id.au",
  ".idv.hk",
  ".ie",
  ".il",
  ".im",
  ".in",
  ".info",
  ".int.ar",
  ".io",
  ".iq",
  ".ir",
  ".is",
  ".it",
  ".je",
  ".jm",
  ".jo",
  ".jobs",
  ".jp",
  ".ke",
  ".kg",
  ".kh",
  ".ki",
  ".km",
  ".kn",
  ".kp",
  ".kr",
  ".kw",
  ".ky",
  ".kz",
  ".la",
  ".law",
  ".lb",
  ".lc",
  ".li",
  ".lk",
  ".lr",
  ".ls",
  ".lt",
  ".ltd",
  ".lu",
  ".lv",
  ".ly",
  ".ma",
  ".mc",
  ".md",
  ".me",
  ".me.uk",
  ".media",
  ".mg",
  ".mk",
  ".ml",
  ".mm",
  ".mn",
  ".mo",
  ".mobi",
  ".mr",
  ".ms",
  ".mt",
  ".mu",
  ".museum",
  ".mv",
  ".mw",
  ".mx",
  ".my",
  ".mz",
  ".na",
  ".name",
  ".nc",
  ".ne",
  ".ne.jp",
  ".net",
  ".net.ar",
  ".net.au",
  ".net.br",
  ".net.cn",
  ".net.eg",
  ".net.hk",
  ".net.in",
  ".net.mx",
  ".net.my",
  ".net.nz",
  ".net.ph",
  ".net.pk",
  ".net.sa",
  ".net.sg",
  ".net.tr",
  ".net.ua",
  ".net.uk",
  ".net.vn",
  ".net.za",
  ".network",
  ".news",
  ".ng",
  ".nhs.uk",
  ".ni",
  ".nl",
  ".no",
  ".np",
  ".nr",
  ".nu",
  ".nz",
  ".om",
  ".online",
  ".or.jp",
  ".or.ke",
  ".org",
  ".org.ar",
  ".org.au",
  ".org.br",
  ".org.cn",
  ".org.eg",
  ".org.hk",
  ".org.in",
  ".org.mx",
  ".org.my",
  ".org.nz",
  ".org.ph",
  ".org.pk",
  ".org.sa",
  ".org.sg",
  ".org.tr",
  ".org.ua",
  ".org.uk",
  ".org.vn",
  ".org.za",
  ".pa",
  ".pe",
  ".per.sg",
  ".pg",
  ".ph",
  ".pk",
  ".pl",
  ".plc.uk",
  ".pn",
  ".pro",
  ".ps",
  ".pt",
  ".pub",
  ".pw",
  ".py",
  ".qa",
  ".re",
  ".res.in",
  ".ro",
  ".rs",
  ".ru",
  ".rw",
  ".sa",
  ".sb",
  ".sc",
  ".sch.uk",
  ".school.nz",
  ".sd",
  ".se",
  ".services",
  ".sg",
  ".sh",
  ".shop",
  ".si",
  ".sk",
  ".sl",
  ".sm",
  ".sn",
  ".so",
  ".social",
  ".software",
  ".solutions",
  ".space",
  ".sr",
  ".ss",
  ".st",
  ".store",
  ".studio",
  ".support",
  ".sv",
  ".sy",
  ".systems",
  ".sz",
  ".tc",
  ".td",
  ".tech",
  ".tg",
  ".th",
  ".tj",
  ".tk",
  ".tl",
  ".tm",
  ".tn",
  ".to",
  ".today",
  ".tools",
  ".tr",
  ".tt",
  ".tv",
  ".tw",
  ".tz",
  ".ua",
  ".ug",
  ".uk",
  ".us",
  ".uy",
  ".uz",
  ".va",
  ".vc",
  ".ve",
  ".vg",
  ".vi",
  ".vn",
  ".vu",
  ".website",
  ".wiki",
  ".world",
  ".ws",
  ".ye",
  ".yt",
  ".za",
  ".zm",
  ".zw"
]
